import { rules } from './rules';

export const validator = {
  rules,
  std_form_error: 'Ошибка валидации, проверьте форму.'
};
